<div class="text-info-content">
  @if (hasDictionaryInfo()) {
    <div class="text-info-content__definition">
      @if (isWiktionaryResponse()) {
        <span class="text-info-content__definition-label">
          {{ 'WORD_INFO.DICTIONARY' | translate }}
        </span>
        <div class="text-info-content__definition-text" [innerHTML]="wiktionaryHtml()"></div>
        <odl-button
          class="text-info-content__definition-more-info-button"
          variant="text"
          size="small"
          (click)="showMoreInfo.emit('dictionary')"
        >
          {{ 'WORD_INFO.MORE_INFO' | translate }}
          <odl-icon name="navigate_next" slot="end"></odl-icon>
        </odl-button>
      } @else {
        <span class="text-info-content__definition-label">
          {{ 'WORD_INFO.DEFINITION' | translate }}
        </span>
        <div class="text-info-content__definition-content">
          <p class="text-info-content__definition-text">
            {{ textInfo()?.definition }}
          </p>
          <small class="text-info-content__definition-ai-info">
            {{ 'WORD_INFO.AI_INFO' | translate }}
          </small>
          <odl-button
            class="text-info-content__definition-more-info-button"
            variant="text"
            size="small"
            (click)="showMoreInfo.emit('dictionary')"
          >
            {{ 'WORD_INFO.MORE_INFO' | translate }}
            <odl-icon name="navigate_next" slot="end"></odl-icon>
          </odl-button>
        </div>
      }
    </div>
  }

  @if (hasWikipediaInfo()) {
    <div class="text-info-content__definition">
      <span class="text-info-content__definition-label">
        {{ 'WORD_INFO.WIKIPEDIA' | translate }}
      </span>
      <div class="text-info-content__definition-text" [innerHTML]="wikipediaHtml()"></div>
      <odl-button
        class="text-info-content__definition-more-info-button"
        variant="text"
        size="small"
        (click)="showMoreInfo.emit('wikipedia')"
      >
        {{ 'WORD_INFO.MORE_INFO' | translate }}
        <odl-icon name="navigate_next" slot="end"></odl-icon>
      </odl-button>
    </div>
  }

  <div class="text-info-content__translator">
    <span class="text-info-content__translator-label">
      {{ 'WORD_INFO.TRANSLATOR' | translate }}
    </span>
    <div class="text-info-content__translator-content">
      <div class="text-info-content__translator-content-selectors">
        <odl-select
          class="text-info-content__translator-content-selectors-selector"
          [formControl]="originLanguageSelector"
          [description]="'WORD_INFO.SOURCE_LANGUAGE' | translate"
          (odl-input)="handleOriginLanguageChange($event)"
        >
          @for (language of languageOptions; track language.code) {
            <odl-option [value]="language.code">{{ language.name | translate }}</odl-option>
          }
        </odl-select>
        <odl-icon
          class="text-info-content__translator-content-selectors-icon"
          name="arrow_forward"
          slot="only-icon"
        ></odl-icon>
        <odl-select
          class="text-info-content__translator-content-selectors-selector"
          [formControl]="targetLanguageSelector"
          [description]="'WORD_INFO.TARGET_LANGUAGE' | translate"
          (odl-input)="handleTargetLanguageChange($event)"
        >
          @for (language of languageOptions; track language.code) {
            <odl-option [value]="language.code">{{ language.name | translate }}</odl-option>
          }
        </odl-select>
      </div>
      <div class="text-info-content__translator-content-translation">
        <small class="text-info-content__translator-content-translation-label">
          {{ originLanguage() | translate }}
        </small>
        <div class="text-info-content__translator-content-translation-result">
          <odl-button
            [description]="(speakingText() === wordText() ? 'TTS.PAUSE' : 'TTS.PLAY') | translate"
            (click)="speak(wordText(), translation()?.detectedSourceLanguage)"
          >
            <odl-icon
              [name]="speakingText() === wordText() ? 'pause' : 'volume_up'"
              slot="only-icon"
            ></odl-icon>
          </odl-button>
          <span class="text-info-content__translator-content-translation-text">
            {{ wordText() }}
          </span>
        </div>
      </div>
      <div class="text-info-content__translator-content-translation">
        <small class="text-info-content__translator-content-translation-label">
          {{ targetLanguage() | translate }}
        </small>
        <div class="text-info-content__translator-content-translation-result">
          <odl-button
            [description]="
              (speakingText() === translation()?.translatedText ? 'TTS.PAUSE' : 'TTS.PLAY')
                | translate
            "
            (click)="speak(translation()?.translatedText, translation()?.oppositeLanguage)"
          >
            <odl-icon
              [name]="speakingText() === translation()?.translatedText ? 'pause' : 'volume_up'"
              slot="only-icon"
            ></odl-icon>
          </odl-button>
          <span class="text-info-content__translator-content-translation-text">
            {{ translation()?.translatedText }}
          </span>
        </div>
      </div>
      <nr-translator-watermark
        class="text-info-content__translator-content-watermark"
      ></nr-translator-watermark>
    </div>
  </div>
</div>
